module.exports = __webpack_public_path__ + "img/man-walking.b3fe12bc.gif";